import { http, HttpResponse, PathParams } from 'msw';
import { apiUrl } from '../apiUrl';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { composeServerError, validateNewPassword, otpHandler, validatePasswordInSettingsFlow } from './shared';

export const changePasswordVerifyTotpMutation = http.post(apiUrl(AccountApiPaths.changePasswordVerifyTotp), otpHandler);

// change password
export const changePasswordMutation = http.post<PathParams, { oldPassword: string; newPassword: string }>(
    apiUrl(AccountApiPaths.changePassword),
    async ({ request }) => {
        const body = await request.json();
        const { oldPassword, newPassword } = body;
        const error = validatePasswordInSettingsFlow(oldPassword) || validateNewPassword(newPassword);
        return error ? composeServerError(request, error) : new HttpResponse();
    }
);

export const changePasswordHandlers = [changePasswordVerifyTotpMutation, changePasswordMutation];
